<template>
  <div class="outDiv">
    <div class="searchBar">
      <div class="searchLeft">
        <el-popover
          placement="right-bottom"
          title="条件检索"
          trigger="click"
          v-model="searchVisible"
        >
          <searchForm
            @startSearch="handleTableSearch"
            @cancleSearch="handleCancleSeach"
          ></searchForm>
          <el-button slot="reference" size="mini">按条件筛选</el-button>
        </el-popover>
        <navTopTag
          :searchTagList="searchTagList"
          @handleDelOne="handleDelOne"
        ></navTopTag>
      </div>
    </div>
    <div>
      <BaseStatistics :statisticData="baseStaArr"></BaseStatistics>
    </div>
    <div>
      <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
        <el-tab-pane
          label="在册老人"
          name="all"
          ref="all"
          id="allTab"
        ></el-tab-pane>
        <el-tab-pane label="已注销" name="logout"></el-tab-pane>
        <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
      </el-tabs>
      <div class="tableContainer">
        <baseTable
          :columns="allTableObj.columns"
          :dataList="allTableObj.dataList"
          :options="allTableObj.options"
          :loadObj="allTableObj.loadObj"
          :operationColumn="allTableObj.operationColumn"
          :fenyeObj="allTableObj.fenyeObj"
          @dataSizeChange="handleSizeChange($event, allTableObj)"
          @dataCurrentChange="handleCurrentChange($event, allTableObj)"
        ></baseTable>
      </div>
    </div>
    <el-dialog :visible.sync="typeSelectShow" center width="60%">
      <el-form labelWidth="160px" labelPosition="right" size="mini">
        <el-form-item label="老人账户余额">
          <el-row :span="24">
            <el-col :span="4">
              <span>
                个人账户:
                <span style="margin: 0px 5px">{{ olderMoney.person }}</span> 元
              </span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>
                基础补助余额:
                <span style="margin: 0px 5px">{{ olderMoney.grant }}</span> 元
              </span>
            </el-col>
            <el-col :span="6" :offset="1">
              <span>
                当月就餐服务剩余天数:
                <span style="margin: 0px 5px">{{ olderMoney.dining }}</span
                >天
              </span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="选择订单类型">
          <el-select v-model="orderType">
            <el-option label="上门服务" value="1"></el-option>
            <el-option label="送餐" value="2"></el-option>
            <el-option label="养老机构" value="3"></el-option>
            <el-option label="日间照料中心" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" @click="selectOrderType">确定</el-button>
          <el-button
            @click="
              () => {
                this.typeSelectShow = false;
              }
            "
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import searchForm from "./components/search-form.vue";
import dataApi from "./_api/api";
import { request } from "https";
import { mapState } from "vuex"
import { getOlderList, getOlderAccountStasticApi } from "@/services/all-api.js"
export default {
  components: {
    searchForm
  },
  computed: {
    ...mapState(['currentSearchForm'])
  },
  data() {
    return {
      olderMoney: {},
      oneOldGid: "",
      theOldPhone: "",
      orderType: "",
      typeSelectShow: false,
      popoverList:
        { btnName: "下单" }
      ,
      searchTagList: [],
      baseStaArr: [
        // { name: "A1类老人", number: "", value: "a1TheOld" },
        // { name: "A2类老人", number: "", value: "a2TheOld" },
        // { name: "A3类老人", number: "", value: "a3TheOld" },
        // { name: "B1类老人", number: "", value: "b1TheOld" },
        // { name: "B2类老人", number: "", value: "b2TheOld" },
        // { name: "B3类老人", number: "", value: "b3TheOld" },
        // { name: "其他老人", number: "", value: "sTheOld" },
        // { name: "已注销老人", number: "", value: "theCancel" }

         { name: "A1类老人", number: "", value: "a1TheOld" },
        { name: "A2类老人", number: "", value: "a2TheOld" },
        { name: "A3类老人", number: "", value: "a3TheOld" },
        { name: "A4类老人", number: "", value: "a4TheOld" },
        { name: "B类老人", number: "", value: "bTheOld" },

        { name: "其他老人", number: "", value: "sTheOld" },
        { name: "已注销老人", number: "", value: "theCancel" },
      ],
      searchVisible: false,
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "50px",
            align: "center"
          },
          {
            prop: "olderName",
            label: "姓名",
            align: "center",
            route: true,
            method: (index, row) => {
              this.handleDetail(index, row)
            }
          },
          {
            prop: "gender",
            label: "性别",
            align: "center"
          },
          {
            prop: "pushToTalk",
            label: "一键通号码",
            align: "center"
          },
          {
            prop: "pushToTalkType",
            label: "一键通类型",
            align: "center"
          },
          {
            prop: "age",
            label: "年龄",
            align: "center"
          },
          {
            prop: "type",
            label: "老人类型",
            align: "center"
          },
          {
            prop: "idCard",
            label: "身份证号",
            align: "center",
            width: "200px"
          },
          {
            prop: "isBaseInfoPerfect",
            label: "基础信息",
            align: "center",
            render: (h, params) => {
              return h("span", { style: params.row.isBaseInfoPerfect === true ? "color:#67C23A" : "color:#E6A23C" }, params.row.isBaseInfoPerfect === true ? "已完善" : "未完善")
            }
          },
          {
            prop: "hasFaceInfo",
            label: "人脸信息",
            align: "center",
            render: (h, params) => {
              return h("span", { style: params.row.hasFaceInfo === true ? "color:#67C23A" : "color:#E6A23C" }, params.row.hasFaceInfo === true ? "已完善" : "未完善")
            }
          },
          {
            prop: "phone",
            label: "手机号",
            align: "center"
          },
          {
            prop: "community",
            label: "所属社区",
            align: "center",
            width: "180px"
          }
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead
        },
        loadObj: {
          isLoading: false
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        logoutDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              style: "font-size:16px",
              disabled: false,
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            },
            {
              size: "mini",
              icon: "el-icon-bottom",
              type: "text",
              style: "font-size:16px",
              disabled: false,
              method: (index, row) => {
                this.handleOrder(index, row)
              }
            }
          ]
          // otherBtn: [
          //   {
          //     item: "status",
          //     value: [0],
          //     type: "text",
          //     size: "mini",
          //     icon: "el-icon-delete",
          //     style: "color:red;font-size:16px",
          //     method: (index, row) => {
          //       this.handleDelete(index, row);
          //     }
          //   },
          // ]
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0
        },
        currentTab: "all",
        searchObj: {}
      }
    };
  },
  methods: {
    listTrans(obj) {
      const result = {
        data: obj.data.map((item, i) => ({
          gid: item.gid,
          num: obj.index * obj.size + i + 1,
          olderName: item.name,
          age: item.age,
          type:
           

                   item.type == 1
              ? "A1类老人"
              :item.type == 2
                ? "A2类老人"
                : item.type == 3
                  ? "A3类老人"
                  : item.type == 4
                  ? "A4类老人"
                  : "B类老人",
          idCard: item.idCard,
          gender: item.gender == 0 ? "女" : "男",
          pushToTalk: item.pushToTalk || "-",
          pushToTalkType: item.pushToTalkType || "-",
          pensionMode:
            item.pensionMode == "0"
              ? "居家养老"
              : item.pensionMode == "1"
                ? "机构养老"
                : "社区养老",
          phone: item.phone,
          community: item.community || "-"
        })),
        total: obj.total,
        index: obj.index,
        size: obj.size
      };
      return result;
    },
    getOldersStastic() {
      this.$xiaLaList.getOlderStatistic().then(res => {
        this.baseStaArr = this.$baseFunc.getStasticCommon(res, this.baseStaArr);
      });
    },
    addOne() {
      this.$router.push("/olders/oldermanage/olderadd");
    },
    handleTableSearch(i) {
      this.searchVisible = i.searchShow;
      this.searchTagList = this.getTagList(
        this.getOlderSearch(),
        i.searchData
      );
      this.$store.commit("setSearchForm", i.searchData);
      this.allTableObj.searchObj = i.searchData;
      this.allTableObj.currentTab = "search";
      const reqObj = {
        index: 0,
        size: 20,
        ...i.searchData
      };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCancleSeach(i) {
      this.searchVisible = i.searchShow;
    },
    handleDelOne(i) {
      //减少一个检索条件时
      this.searchTagList = this.searchTagList.filter((item, index) => {
        if (item[0] === i[0]) {
          return false;
        } else {
          return true;
        }
      });
      const obj = this.deleteOneSearch(
        i[0],
        this.$store.state.currentSearchForm
      );
      if (this.$baseFunc.paramsValidate(obj)) {
        this.allTableObj.searchDataNow.dataList = [];
        this.allTableObj.searchDataNow.currentPage = 1;
        this.allTableObj.searchDataNow.pageSize = 20;
        this.allTableObj.searchDataNow.total = 0;
        this.allTableObj.currentTab = "all";
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      } else {
        const reqObj = {
          index: 0,
          size: 20,
          ...obj
        };
        this.pageSearchGet(reqObj, this.allTableObj);
      }
      this.$store.commit("setSearchForm", obj);
    },
    tabClick(i) {
      if (i.name == "all") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.$nextTick().then(() => {
          this.allTableObj.fenyeObj.showPage = true;
          this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        });
      }
      if (i.name === "logout") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.logoutDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.logoutDataNow.total;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.logoutDataNow.pageSize;
        this.$nextTick().then(() => {
          this.allTableObj.fenyeObj.showPage = true;
          this.allTableObj.fenyeObj.currentPage = this.allTableObj.logoutDataNow.currentPage
        })
      }
      if (i.name == "search") {
        this.allTableObj.dataList = this.allTableObj.searchDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.searchDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.searchDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.searchDataNow.total;
      }
    },
    firstGetAll(obj) {
      obj.loadObj.isLoading = true;
      dataApi
        .firstGet()
        .then(res => {
          //先缓存
          obj.allDataNow.dataList = res.allData.data;
          obj.allDataNow.total = res.allData.total;
          obj.logoutDataNow.dataList = res.logoutData.data;
          obj.logoutDataNow.total = res.logoutData.total;
          //最后赋值  默认全部
          obj.dataList = res.allData.data;
          obj.fenyeObj.total = res.allData.total;
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    //检索条件或者分页等变化时请求数据
    pageSearchGet(reqobj, obj) {
      const flag = obj.currentTab;
      obj.loadObj.isLoading = true;
      let endObj = reqobj;
      if (flag === "logout") {
        endObj = { ...reqobj, status: 2 }
      }
      dataApi
        .pageSearchGetFunc(endObj)
        .then(res => {
          if (flag == "all") {
            obj.allDataNow.dataList = res.data.data;
            obj.allDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.allDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.allDataNow.pageSize;
            obj.dataList = obj.allDataNow.dataList;
            obj.fenyeObj.total = obj.allDataNow.total;
            return false;
          }
          else if (flag === "logout") {
            obj.logoutDataNow.dataList = res.data.data;
            obj.logoutDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.logoutDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.logoutDataNow.pageSize;
            obj.dataList = obj.logoutDataNow.dataList;
            obj.fenyeObj.total = obj.logoutDataNow.total;
            return false;
          }
          else if (flag == "search") {
            obj.searchDataNow.dataList = res.data.data;
            obj.searchDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
            obj.dataList = obj.searchDataNow.dataList;
            obj.fenyeObj.total = obj.searchDataNow.total;
            return false;
          }
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    //每次页面码数变了 要变回第一页
    handleSizeChange(i, obj) {
      let reqObj = {};
      if (obj.currentTab == "all") {
        obj.allDataNow.currentPage = 1;
        obj.allDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i
        };
      }
      else if (obj.currentTab === "logout") {
        obj.logoutDataNow.currentPage = 1;
        obj.logoutDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i
        }
      }
      else if (obj.currentTab == "search") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCurrentChange(i, obj) {
      let reqObj = {};
      let flag = obj.currentTab;
      if (flag == "all") {
        obj.allDataNow.currentPage = i;
        obj.allDataNow.pageSize = obj.allDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.allDataNow.pageSize
        };
      } else if (flag == "search") {
        obj.searchDataNow.currentPage = i;
        obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.searchDataNow.pageSize,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleDetail(i, j) {
      this.$router.push({
        path: "olderList/detail"
      });
      const temp = {
        theOldGid: j.gid,
        theOldName: j.olderName,
        status: j.status,
        theOldPhone: j.phone
      };
      this.$store.commit("SET_ONEOLDER", temp);
    },
    handleOrder(i, j) {
      if (j.status === 2) {
        this.$message.error('已注销老人不能下单')
        return
      }
      getOlderAccountStasticApi({ theOldGid: j.gid }).then(
        res => {
          this.olderMoney = { ...res.data }
        }
      ).finally(() => {
        this.theOldPhone = j.phone
        this.oneOldGid = j.gid
        this.typeSelectShow = true
      })
    },
    selectOrderType() {
      switch (this.orderType) {
        case "1":
          this.routeTo({ path: '/orders/service/create', query: { oneOldGid: this.oneOldGid } });
          break;
        case "2":
          this.routeTo({ path: '/orders/dinner/create', query: { oneOldGid: this.oneOldGid } });
          break;
        case "3":
          this.routeTo({ path: '/orders/beadhouse/create', query: { oneOldGid: this.oneOldGid } });
          break;
        case "4":
          this.routeTo({ path: '/orders/daycare/create', query: { oneOldGid: this.oneOldGid } });
          break;
      }
    },
    handleDelete(i, j) {
      this.$prompt('输入注销老人原因', '注销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '注销原因不能为空'
      }).then(({ value }) => {
        const loading = this.$loading({
          lock: true,
          text: "提交中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        const reqObj = {
          gid: j.gid,
          cancelremark: value
        };
        deleteOlder(reqObj)
          .then(res => {
            loading.close();
            if (res.code === 0) {
              this.$message({
                type: "success",
                message: "老人注销成功"
              });
            } else {
              this.$message({
                type: "error",
                message: `注销失败:${res.des}`
              });
            }
          })
          .catch(() => {
            loading.close();
          })
          .finally(() => {
            loading.close();
          });
      }).catch(() => {
      });
    }
  },
  created() {
    this.getOldersStastic();
    const reqObj = {
      index: 0, size: 20
    }
  },
  mounted() {
    this.firstGetAll(this.allTableObj);
  }
};
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  display: flex;
  flex-flow: column;
}
.searchBar {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .searchLeft {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
}
.tableContainer > div {
  height: calc(100vh - 410px);
}
</style>

